import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import SizePills from "./size-pills/index";
import { fetchClearanceAvailability, fetchClearancePricing } from "slices/pdp-clearance-slice";
import { setSelectedSizeSku } from "slices/pdp-slice";
import AddToBagError from "./add-to-bag-error";
import AddToBag from "./add-to-bag/index";
import ItemUnavailable from "components/source/reservations/item-unavailable";
import { ASSORTMENTS } from "rtr-constants";
import { hasNoAvailableSkus, isSelectedSizeUnavailable } from "./helpers/availability-helper";

export default function ClearanceBuyBox() {
  const [selectedSize, setSelectedSize] = useState(null);
  const staticProduct = useSelector(state => state.staticProduct);
  const availability = useSelector(state => state.pdp?.clearance?.availability?.response?.items);
  const availabilityLoaded = useSelector(state => state.pdp?.clearance?.availability?.loaded);
  const availabilityError = useSelector(state => state.pdp?.clearance?.availability?.error);
  const categoryRoot = useSelector(state => state.staticProduct?.categoryRoot);
  const dispatch = useDispatch();
  const availabilityLoading = !availabilityLoaded;

  useEffect(() => {
    dispatch(fetchClearanceAvailability({ productId: staticProduct.productId }));
    dispatch(fetchClearancePricing({ productId: staticProduct.productId }));
  }, []);
  const handleSizeSelect = size => {
    setSelectedSize(size);
    if (size?.sku) {
      dispatch(setSelectedSizeSku(size.sku));
    }
  };

  // Assume available until availability has loaded
  const styleUnavailable = hasNoAvailableSkus({ availabilityLoaded, availability }, staticProduct?.skus);
  const selectedSizeSku = useSelector(state => state.pdp?.selectedSizeSku);

  const selectedSizeUnavailable = isSelectedSizeUnavailable(selectedSizeSku, availability);

  return (
    <section className="mt-6" data-test-id="clearance-buy-box" aria-labelledby="clearance-add-to-bag">
      <SizePills
        skus={staticProduct.skus}
        availability={availability}
        availabilityLoaded={availabilityLoaded}
        availabilityError={availabilityError}
        onSelect={handleSizeSelect}
        hideOneSize={categoryRoot === ASSORTMENTS.WOMENS_ACCESSORIES}
      />
      {/* shows shop similar styles when the style is completely unavailable for the clearance items. */}
      {!availabilityLoading &&
        (styleUnavailable || (selectedSizeSku && selectedSizeUnavailable) ? (
          <div className="mb-4">
            <ItemUnavailable id={staticProduct.productId} sku={selectedSize} remaining={0} unexpectedError={null} />
          </div>
        ) : (
          <>
            <AddToBagError />
            <AddToBag
              membershipError={null}
              availability={availability}
              availabilityLoaded={availabilityLoaded}
              selectedSize={selectedSize}
              isClearance={true}
            />
          </>
        ))}
      <p className="my-4 md:my-0">All purchases are final.</p>
    </section>
  );
}
